// src/data/data.js

export const categories = [
  { title: "Computer Accessories", icon: "💻" },
  { title: "Printers & Consumables", icon: "🖨️" },
  { title: "Networking & Security", icon: "🌐" },
  { title: "Office Equipment & Display Solutions", icon: "🪑" },
  { title: "Storage & Cables", icon: "💾" },
  { title: "Software & Services", icon: "🛠️" },
  { title: "Corporate Solutions", icon: "🏢" },
];

export const featured = [
  {
    title: "27\" Curved Monitor - 144Hz",
    price: "AED 1,099",
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?auto=format&fit=crop&w=800&q=60",
  },
  {
    title: "Wireless Keyboard + Mouse Combo",
    price: "AED 169",
    img: "/assets/img/products/officesuppliesmouse.png",
  },
  {
    title: "4K Webcam - Conference Ready",
    price: "AED 299",
    img: "/assets/img/products/officesupplies4k.png",
  },
];

export const services = [
  {
    title: "CCTV & Access Control",
    desc: "Secure your premises with professional design, supply & installation.",
    img: "/assets/img/services/officesuppliescctv1.png",
  },
  {
    title: "Network Setup & Wi‑Fi Design",
    desc: "High‑performance structured cabling and configuration for seamless connectivity.",
    img: "/assets/img/services/officesuppliesnetwork.png",
  },
  {
    title: "Printer Leasing & AMC",
    desc: "Flexible leasing plans and comprehensive maintenance for your office printers.",
    img: "/assets/img/services/officesuppliesprinter.png",
  },
  {
    title: "IT Support & Maintenance",
    desc: "On‑site and remote IT assistance to keep your systems running smoothly.",
    img: "/assets/img/services/officesuppliesit.png",
  },
  {
    title: "Office Setup Solutions",
    desc: "End‑to‑end solutions — from planning to execution and complete setup.",
    img: "/assets/img/services/officesuppliesset.png",
  },
];

export const brands = [
  { name: "Samsung", logo: "https://upload.wikimedia.org/wikipedia/commons/2/24/Samsung_Logo.svg" },
  { name: "HP", logo: "https://upload.wikimedia.org/wikipedia/commons/3/3a/HP_logo_2012.svg" },
  { name: "Wacom", logo: "https://upload.wikimedia.org/wikipedia/commons/4/4a/Wacom_logo.svg" },
  { name: "Logitech", logo: "https://upload.wikimedia.org/wikipedia/commons/3/3e/Logitech_logo.svg" },
  { name: "Cisco", logo: "https://upload.wikimedia.org/wikipedia/commons/6/64/Cisco_logo_blue_2016.svg" },
];